<template>
  <div class="laneList">
    <!-- <div class="laneListCommorCont crumbs"><a href="/">Home</a>>Highlights</div> -->
    <div class="laneListCommorCont laneListsection">
      <!-- :to="{ path: pageName, query: { id: item.id, type: item.type } }"
         :to="{ path: pageName/item.id/item.type}" -->
      <h2 class="mod-title">
        <strong>{{ title }}</strong>
      </h2>
      <div class="LaneItem-con">
        <div class="LaneItem" v-for="(item, index) in allList" :key="index">
          <router-link :to="typeObj[item.type+''] + '/' + item.type + '/' + item.id">
            <div class="imgBox">
              <img :src="item.picurl" alt="" />
            </div>
            <p class="title">{{ item.title }}</p>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 加载更多   12-2 需求说是不需要分页  这直接显示全部list -->
    <!-- <div class="loadMore">
      <div class="btn">加载更多</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LaneList",
  data() {
    return {
      //路由传参
      detaileId: "",
      //全部 list
      allList: "",
      //跳转页面
      title:'',
      id: "",
      typeObj:{
        ezfm:"/columnList",
        other:"/columnList",
        recommend:"/detail",
        ezfmHistory:"/detail",
        otherHistory:"/detail",
        more:"/detail",
        lane:"/laneList"
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    typeToOther(item) {
      var _this = this;
      var type = (_this.type = item.type);
    },
   
    getList() {
      var _this = this;
      _this.detaileId = parseInt(_this.$route.params.newsId);

      // 接口 https://aezfm.meldingcloud.com/v3/lane/detail?id=133&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4
      _this.$http
        .post("/qertyuiy/v3/lane/detail?id=" + _this.detaileId)
        .then(function (res) {
          _this.allList = res.data.data.data;
          _this.title = res.data.data.title;
          document.title = res.data.data.title;
          $("meta[name='description']").attr('content',''+res.data.data.info+'');
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
body,
html {
  font-family: "Microsoft YaHei", sans-serif;
  width: 100%;
  height: 100%;
}
.laneList {
  background: #f3f4f5;
}
.laneListCommorCont {
  width: 1280px;
  margin: 0 auto;
}
// 导航栏
.crumbs {
  font-size: 14px;
  color: #999;
  height: 64px;
  line-height: 54px;
  a {
    font-size: 14px;
    color: #999;
  }
}
/**/
.mod-title {
  line-height: 34px;
}
.mod-title strong {
  font-size: 28px;
  font-weight: 400;
}
.mod-title .more {
  float: right;
  color: #0085cb;
  font-size: 24px;
  font-weight: 400;
}
//
// 容器List
.laneListsection {
  margin-top: 30px;
  // 单个box
  .LaneItem-con{width: 100%;display: flex;flex-wrap: wrap;margin-top: 20px;}
  .LaneItem {
    width: 305px;
    background: #fff;
    margin-right: 20px;
    margin-bottom: 30px;
    padding-bottom: 40px;
    // 图片盒子
    .imgBox {
      width: 305px;
      height: 200px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 标题 p
    .title {
      line-height: 30px;
      padding: 40px 30px 0;
      font-size: 16px;
      color: #666;
      background: none;
    }
  }
  .LaneItem:nth-child(4n) {
    margin-right: 0;
  }
  .LaneItem:hover {
    cursor: pointer;
  }
}
//loadMore 加载更多
.loadMore {
  text-align: center;
  .btn {
    width: 70px;
    height: 40px;
    background-color: #31a9de;
    border-radius: 5px;
    color: white;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin: 0 auto;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 900px) {
  .laneList {
    background: #fff;
  }
  * {
    box-sizing: border-box;
  }
  /**/
  .mod-title {
    line-height: 0.34rem;
  }
  .mod-title strong {
    font-size: 0.36rem;
    font-weight: 400;
    display: block;
  }
  .mod-title .more {
    float: right;
    color: #0085cb;
    font-size: 0.22rem;
    font-weight: 400;
  }
  // 适配移动端
  .laneListCommorCont {
    width: 100%;
  }
  .laneListsection {
    margin-top: .3rem;
    .LaneItem-con{margin-top: .2rem;}
    .LaneItem {
      position: relative;
      width: 100%;
      margin-bottom: .3rem;
      margin-right: 0;
      padding-bottom: 0;
      .imgBox {
        // height: 250px;
        // overflow: hidden;
        width: 100%;
        height: auto;
        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }
      .title {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px 10px;
        line-height: 18px;
        font-size: 12px;
        overflow: hidden;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.6);
      }
    }
  }
  //隐藏
  .crumbs {
    display: none;
  }

  .LaneItem:nth-child(4n) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/LaneList.vue